export interface SupplierState {
  preQueueItems: PreQueue[]
  preQueueDeletedItems: PreQueue[]
  lastUpdatedInfo: LastUpdatedInfo
}

export interface LastUpdatedInfo {
  dateOrMessage: string
  error: string | boolean
}

export interface PreQueueInvoices {
  id: number
  idAr?: number
  idPreQueue: number
  invoiceKey: string
  bankSlips: BankSlip[]
  arStatus: string
  ready: boolean
}

export interface BankSlip {
  id: number
  idReceivement?: number
  idReceivementAr?: number
  nfKey: string
  barcode: string
}

export interface PreQueue {
  attendancePassword: string
  id: number
  idFulfillmentCenter: number
  idSupplier?: number
  idUsrCreated: number
  invoices: PreQueueInvoices[]
  createdAt: Date
  supplier: Supplier
  deleted: boolean
  deletedAt: Date
  supplierName: string
}

interface Supplier {
  idMeiodePedido: number,
  idFornecedor: number,
  nmFornecedor: string
}

export enum GenericApiErrors {
  Failed,
}

export interface GetPreQueuePayload {
  fcId: string
}

export interface PreQueueInvoicesPayload {
  badge: string
  preQueueId: number
}

export interface PreQueueInvoicesPayloadSagas {
  badge: string
  preQueueId: number
  fcId: string
  onFinally: () => void
  onReleaseIncompatibleInvoices?: (incompatibleInvoices: PreQueueIncompatibleInvoices) => void
}

export interface ValidateBilletBarcodePayloadSagas {
  barcode: string
  onSuccess: () => void
  onFail: (message: string) => void
}

export interface ReleasePreQueueInvoicesResponse {
  idReceivement: number
  message: string
}

export interface PreQueueInvoicesResponse {
  preQueue: PreQueue[]
  deletedPreQueue: PreQueue[]
}

export enum SupplierReceivementTypeEnum {
  SUPPLIER = 'Fornecedor',
  EXTERNAL_BUYER = 'Comprador Externo',
  TRANSFER = 'Transferência'
}

export enum ReceivementAuthorizationTypeEnum {
  REGULAR = 1,
  EXTERNAL_ORDER = 2,
  TRANSFER_ORDER = 3
}

export enum ReceivementCategoryEnum {
  NORMAL = 1,
  EXTERNAL_PURCHASE = 2,
  TRANSFER = 3
}

export interface ValidateExternalPurchaseOrderCodePayload {
  externalPurchaseOrderCode: string
  onSuccess: () => void
  onFail: (message: string) => void
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
}

export interface IncompatibleInvoices {
  message: string
  invoices: string[]
}

export interface PreQueueIncompatibleInvoices {
  regular: IncompatibleInvoices
  externalOrder: IncompatibleInvoices
  transferOrderRegular: IncompatibleInvoices
  transferOrder: IncompatibleInvoices
}
